import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/20.png';
import _imports_1 from '../../../assets/new/30.png';
import _imports_2 from '../../../assets/new/19.png';
import _imports_3 from '../../../assets/new/21.png';
import _imports_4 from '../../../assets/new/22.png';
import _imports_5 from '../../../assets/new/23.png';
import _imports_6 from '../../../assets/new/29.png';
import _imports_7 from '../../../assets/new/24.png';
import _imports_8 from '../../../assets/new/25.png';
import _imports_9 from '../../../assets/new/26.png';
import _imports_10 from '../../../assets/new/27.png';
import _imports_11 from '../../../assets/new/28.png';
import _imports_12 from '../../../assets/new/49.png';
import _imports_13 from '../../../assets/new/9.png';
import _imports_14 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-70aea415"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user"
};
const _hoisted_2 = {
  href: "javascript: void(0)"
};
const _hoisted_3 = {
  key: 0,
  src: _imports_0
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "signIn"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}), /*#__PURE__*/_createTextVNode(" 签到 ")], -1));
const _hoisted_7 = {
  class: "container"
};
const _hoisted_8 = {
  class: "read"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_11 = {
  class: "cells"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}), /*#__PURE__*/_createElementVNode("h4", null, "我的课程")], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}), /*#__PURE__*/_createElementVNode("h4", null, "阅读等级")], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8
}), /*#__PURE__*/_createElementVNode("h4", null, "设置学校信息")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8
}), /*#__PURE__*/_createElementVNode("h4", null, "设置阅读能力")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8
}), /*#__PURE__*/_createElementVNode("h4", null, "会员中心")], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<a href=\"javascript: void(0)\" class=\"cell\" data-v-70aea415><div class=\"left\" data-v-70aea415><img src=\"" + _imports_9 + "\" data-v-70aea415><h4 data-v-70aea415>我的收藏</h4></div><div class=\"right\" data-v-70aea415><img src=\"" + _imports_6 + "\" data-v-70aea415></div></a>", 1);
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<a href=\"javascript: void(0)\" class=\"cell\" data-v-70aea415><div class=\"left\" data-v-70aea415><img src=\"" + _imports_10 + "\" data-v-70aea415><h4 data-v-70aea415>帮助与反馈</h4></div><div class=\"right\" data-v-70aea415><img src=\"" + _imports_6 + "\" data-v-70aea415></div></a>", 1);
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_11
}), /*#__PURE__*/_createElementVNode("h4", null, "退出登录")], -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
const _hoisted_31 = [_hoisted_29, _hoisted_30];
const _hoisted_32 = {
  key: 0,
  style: {
    "height": "6rem"
  }
};
const _hoisted_33 = {
  class: "footer"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13
}, null, -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14
}, null, -1));
const _hoisted_37 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "width": "100%"
  }
};
import { onMounted, computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { setNickName } from "../../../api/index";
export default {
  __name: 'my_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const pid = getLocalPid();
    const store = useStore();
    const router = useRouter();
    const token = computed(() => store.state.token);
    const userId = computed(() => store.state.userId);
    const sign = computed(() => store.state.sign);
    const userInfo = computed(() => store.state.userInfo || {});
    const form = ref({
      token: token.value,
      sign: sign.value,
      userId: userId.value,
      nickname: ""
    });
    console.log(userInfo.value);
    onMounted(() => {
      if (!token.value) {
        getToken();
      } else if (token.value && !userInfo.value.nickname) {
        store.dispatch("getUserInfo", "article");
      }
      let title = localStorage.getItem("title");
      if (title) {
        document.title = title;
      }
    });
    const dialogFormVisible = ref(false);
    const saveNickName = () => {
      setNickName(form.value).then(res => {
        console.log(res);
        if (res.data.code === 0) {
          store.dispatch("getUserInfo", "article");
          dialogFormVisible.value = false;
        }
      });
    };
    const exit = () => {
      store.commit("exit");
      router.push({
        name: "home",
        query: {
          pid: getLocalPid()
        }
      });
    };
    const getToken = () => {
      store.commit("init");
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([isMobile.value ? 'containerM' : 'containerPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", _hoisted_2, [_createElementVNode("div", null, [!userInfo.value.avatar ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: userInfo.value.avatar
      }, null, 8, _hoisted_4)), _createElementVNode("div", null, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(userInfo.value.nickname || "蓝宝宝"), 1), _createElementVNode("span", null, "V" + _toDisplayString(userInfo.value.level), 1)]), _createElementVNode("div", null, "ID：" + _toDisplayString(userInfo.value.id), 1)])]), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => dialogFormVisible.value = true)
      }, [_createTextVNode(" 修改昵称 "), _hoisted_5])]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'plan',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_9, _createTextVNode(" 阅读计划 ")]), _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'search',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_10, _createTextVNode(" 所有文章 ")])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'myCourse',
          query: {
            pid: _unref(pid)
          }
        }))
      }, _hoisted_14), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'level',
          query: {
            pid: _unref(pid)
          }
        }))
      }, _hoisted_17), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'schoolMes'
        }))
      }, _hoisted_20), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
          name: 'ability'
        }))
      }, _hoisted_23), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[7] || (_cache[7] = $event => _unref(router).push({
          name: 'recharge'
        }))
      }, _hoisted_26), _hoisted_27]), _createElementVNode("div", {
        class: "cells"
      }, [_hoisted_28, _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: exit
      }, _hoisted_31)]), isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_32)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[8] || (_cache[8] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_34, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[9] || (_cache[9] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_35, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[10] || (_cache[10] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_36, _createTextVNode(" 个人中心 ")])])], 2), _createVNode(_component_el_dialog, {
        title: "修改昵称",
        width: "80%",
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => dialogFormVisible.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "昵称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.nickname,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.nickname = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            style: {
              "margin": "0"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_button, {
              onClick: _cache[12] || (_cache[12] = $event => dialogFormVisible.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveNickName
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};